module.exports = __webpack_public_path__ + "static/media/realtors-icon-6.4ce76626.svg";